import styled from 'styled-components';
import {
  CenteredSpaceWrap,
  ButtonBase,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';

export const OuterWrapDiv = styled.section(
  props => `
  display:flex;
  width:100%;
  position:sticky;
  top:-.01rem;
  z-index: ${props.theme.misc.zIndex.xlarge};
   background-image: ${props.theme.colors.goBrandImageGradientV2.base};
`,
);

export const WrapperStyle = styled(CenteredSpaceWrap)(
  props => `
  max-width: 120rem;
  width:100%;
  margin: 0 auto;
  padding: ${props.theme.spacing.custom(12)} 0;
   background-image: ${props.theme.colors.goBrandImageGradientV2.base};
`,
);

export const SearchWrapperArea = styled.div(
  props => `
  width: 33.7rem;
  padding-right: ${props.theme.spacing.custom(12)};
  position: relative;
`,
);

export const CheckinCheckoutWrapper = styled.div(
  props => `
  padding-right: ${props.theme.spacing.custom(12)};
  width: 16.5rem;
`,
);

export const PaxWrapperStyle = styled.div(
  props => `
  padding-right: ${props.theme.spacing.small};
  position: relative;
  width: 25.4rem;
`,
);

export const SearchLabelStyle = styled.label`
  ${textSizes.SmallW1}
  color: white;
  padding-bottom: ${props => props.theme.spacing.small};
  padding-left: ${props => props.theme.spacing.custom(2)};
  display: flex;
`;

export const SearchInputStyle = styled.input`
  background-color: ${props => props.theme.colors.goWhite.base};
  color: #222222;
  border: none;
  ${textSizes.MediumW2}
  display: block;
  width: 100%;
  height: 4.2rem;
  padding: ${props => props.theme.spacing.base} ${props => props.theme.spacing.base}
    ${props => props.theme.spacing.custom(12)} ${props => props.theme.spacing.base};
  border-radius: ${props => props.theme.misc.borderRadius.xlarge};
  flex-direction: row;
  align-items: center;
  justify-conent: center;
  &::-webkit-input-placeholder {
    color: white;
    opacity: 0.5;
    ${textSizes.MediumW2}
  }
  &:focus {
    box-shadow: none;
    outline: none;
    ${props => (props.editable === 'false' ? 'color: #66222222;' : '')}
    ${props => (props.editable === 'false' ? 'text-shadow: 0px 0px 0px white;' : '')}
  }
`;

export const UpdateSearchBtn = styled(ButtonBase)`
  ${textSizes.LargeW3}
  background-color: ${props => props.theme.colors.goWhite.base};
  margin-top: ${props => props.theme.spacing.large};
  height: 4.2rem;
  width: 19.6rem;
  color: #166bd3;
  text-transform: none;

  &:disabled {
    opacity: 0.8;
    pointer-events: none;
  }
`;

export const CalendarBlockWrapper = styled.div`
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 14px 0px;
  position: absolute;
  top: 6.5rem;
  z-index: 9;
  border-radius: 1.2rem;
  margin-top: 1rem;
`;
